import React from 'react';
import { Configure } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

// Components
import CompanyListItemRedesign from '@cards/CompanyListItemRedesign';
import SearchContainer from '@search/SearchContainer';
import SearchHits from '@search/SearchHits';

// Functionality
import { SAVED_COMPANIES_QUERY } from '@general/graphql/company.graph';
import { mapSearchCompanyToProps } from '@general/transforms/company.transform';

const SearchRetailersFeatured = ({ displayPagingToolbar = false, selectedEvent, filterString }) => (
    <SearchContainer index="companies">
        <Configure clickAnalytics filters={filterString} hitsPerPage={6} />
        <SearchHits
            HitComponent={CompanyListItemRedesign}
            NoResultsText={() => 'No retailer attendees at your events.'}
            displayPagingToolbar={displayPagingToolbar}
            favoritesProp="companies"
            favoritesQuery={SAVED_COMPANIES_QUERY}
            hitProps={{
                urlQuery: selectedEvent ? `event=${selectedEvent.code}` : null,
            }}
            index="companies"
            resultsPerRow={2}
            searchType="companies"
            shouldLogConversions={false}
            transformFunc={mapSearchCompanyToProps}
        />
    </SearchContainer>
);

SearchRetailersFeatured.propTypes = {
    displayPagingToolbar: PropTypes.bool,
    selectedEvent: PropTypes.shape({
        code: PropTypes.string.isRequired,
    }),
    filterString: PropTypes.string,
};

export default SearchRetailersFeatured;
